import { render, staticRenderFns } from "./RegraFiscalTransportadorForm.vue?vue&type=template&id=4beac834"
import script from "./RegraFiscalTransportadorForm.vue?vue&type=script&lang=js"
export * from "./RegraFiscalTransportadorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports